import { render, staticRenderFns } from "./market.vue?vue&type=template&id=d29c562a&scoped=true&"
import script from "./market.vue?vue&type=script&lang=js&"
export * from "./market.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29c562a",
  null
  
)

export default component.exports